import { FetchResult } from '@apollo/client'

export enum ShopperIdentificationError {
  SHOPPER_NOT_FOUND = 'Shopper with code',
  CHECKING_NOT_FOUND = 'Checking with id',
  MOVEMENT_NOT_OPEN = 'Movement with id',
  INVALID_STATUS_TRANSITION = 'Invalid status transition',
  FAILED_TO_ASSIGN_SHOPPER = 'Failed to assign shopper',
  DELIVERY_ALREADY_PICKING = 'DeliveryAlreadyPicking',
  BAD_REQUEST = 'Bad Request Exception',
  DELIVERY_NOT_FOUND = 'DeliveryNotFound',
  PICKING_ALREADY_ASSIGNED = 'PickingAlreadyAssigned',
}

export type SetIdentificationProps = {
  title: string
  subtitle: string
  isLoading?: boolean
  handleSubmit: (id: string) => Promise<FetchResult<unknown>>
  closeAfterFinish?: boolean
}

export type SetIdentificationContentProps = {
  handleSubmit: (id: string) => Promise<FetchResult<unknown>>
  closeAfterFinish?: boolean
  onClose: () => void
}
